import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import Board1up from '../components/boards/Board1up';
import Board1p1 from '../components/boards/Board1p1';
import Board2up from '../components/boards/Board2up';
import Board2p1 from '../components/boards/Board2p1';
import Ticker from '../components/Ticker';
import { useFirestoreDocRT } from '../hooks/firebase';
import useToasty from '../hooks/toasty';
import useFirework from '../hooks/firework';

const useStyles = makeStyles(() => ({
	root: {
		position: 'fixed',
		left: 0,
		top: 0,
		width: '100vw',
		height: '100vh',
		background: '#002',
	},
	subboard: {
		width: '100vw',
		height: '90vh',
	},
	ticker: {
		width: '100vw',
		height: '8vh',
		marginTop: '1vh',
		marginBottom: '1vh',
	},
}));

export function getSubBoard(type) {
	switch (type) {
	case '1up':
		return Board1up;
	case '1p1':
		return Board1p1;
	case '2up':
		return Board2up;
	case '2p1':
		return Board2p1;
	default:
		return undefined;
	}
}

export default function Board() {
	const { id } = useParams();

	const classes = useStyles();

	const board = useFirestoreDocRT(`boards/${id}`);
	const doToasty = useToasty();
	const doFirework = useFirework();

	const SubBoard = getSubBoard(board?.type);

	const [boardReady, setBoardReady] = useState(false);
	useEffect(() => {
		if (!board || boardReady) return;
		setTimeout(() => setBoardReady(true), 100);
	}, [board, boardReady]);

	const { toasty, firework, refresh } = board || {};
	useEffect(() => {
		if (!boardReady) return;
		doToasty();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toasty, doToasty]);

	useEffect(() => {
		if (!boardReady) return;
		doFirework();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [firework, doFirework]);

	useEffect(() => {
		if (!boardReady) return;
		document.location.reload();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refresh, doFirework]);

	return (
		<div className={classes.root}>
			{SubBoard ? (
				<SubBoard className={classes.subboard} board={board} />
			) : (
				<div className={classes.subboard} />
			)}
			<Ticker className={classes.ticker} />
		</div>
	);
}
